import Icon from "@ant-design/icons";

const icon = () => (
  <svg
    id="Capa_1"
    height="1em"
    viewBox="0 0 512 512"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="m419.996 56.39h-295.404c-11.626 0-21.05 9.424-21.05 21.05v413.51c0 11.626 9.425 21.05 21.05 21.05h295.403c11.626 0 21.05-9.424 21.05-21.05v-413.51c.001-11.625-9.424-21.05-21.049-21.05z"
        fill="#e4936b"
      />
      <path
        d="m419.996 56.39h-20.162c.003.148.005.297.005.446v368.829c0 36.302-29.429 65.731-65.731 65.731h-230.561c.238 11.419 9.569 20.604 21.045 20.604h295.403c11.626 0 21.05-9.424 21.05-21.05v-413.51c.001-11.625-9.424-21.05-21.049-21.05z"
        fill="#e27d47"
      />
      <path
        d="m403.784 87.381h-262.979c-3.463 0-6.271 2.808-6.271 6.271v381.085c0 3.463 2.808 6.271 6.271 6.271h262.979c3.464 0 6.271-2.808 6.271-6.271v-381.085c0-3.463-2.808-6.271-6.271-6.271z"
        fill="#fff9e2"
      />
      <path
        d="m403.784 87.381h-34.936v284.307c0 48.997-39.72 88.717-88.717 88.717h-145.597v14.332c0 3.463 2.808 6.271 6.271 6.271h262.979c3.464 0 6.271-2.808 6.271-6.271v-381.085c0-3.463-2.808-6.271-6.271-6.271z"
        fill="#fbf4c6"
      />
      <path
        d="m360.624 390.954h-176.66c-7.386 0-13.374-5.988-13.374-13.374 0-7.386 5.988-13.374 13.374-13.374h176.659c7.387 0 13.374 5.988 13.374 13.374.001 7.386-5.987 13.374-13.373 13.374z"
        fill="#698ed5"
      />
      <path
        d="m368.847 367.032v4.657c0 6.024-.601 11.908-1.745 17.595 4.112-2.281 6.896-6.667 6.896-11.703 0-4.287-2.016-8.101-5.151-10.549z"
        fill="#4073c8"
      />
      <path
        d="m360.624 443.458h-176.66c-7.386 0-13.374-5.988-13.374-13.374 0-7.386 5.988-13.374 13.374-13.374h176.659c7.387 0 13.374 5.988 13.374 13.374.001 7.386-5.987 13.374-13.373 13.374z"
        fill="#698ed5"
      />
      <path
        d="m360.624 416.709h-4.032c-6.193 10.495-14.485 19.604-24.299 26.749h28.331c7.387 0 13.374-5.988 13.374-13.374s-5.988-13.375-13.374-13.375z"
        fill="#4073c8"
      />
      <circle cx="273.086" cy="237.659" fill="#d0e2e7" r="100.792" />
      <path
        d="m296.33 139.561c22.206 18.489 36.34 46.341 36.34 77.495 0 55.666-45.126 100.792-100.792 100.792-8 0-15.783-.932-23.245-2.694 17.472 14.547 39.94 23.298 64.452 23.298 55.666 0 100.792-45.126 100.792-100.792.001-47.667-33.087-87.604-77.547-98.099z"
        fill="#b4d0d5"
      />
      <circle cx="273.086" cy="237.659" fill="#fbf4c6" r="71.729" />
      <path
        d="m282.851 166.589c12.832 12.96 20.756 30.787 20.756 50.466 0 39.615-32.114 71.729-71.729 71.729-3.312 0-6.572-.225-9.765-.66 13 13.13 31.036 21.263 50.973 21.263 39.615 0 71.729-32.114 71.729-71.729-.001-36.301-26.969-66.305-61.964-71.069z"
        fill="#f9efaf"
      />
      <path
        d="m191.107 343.34-23.702-23.702c-1.24-1.24-3.249-1.24-4.489 0l-91.032 91.032c-1.24 1.24-1.24 3.249 0 4.489l23.702 23.702c1.24 1.24 3.249 1.24 4.489 0l91.032-91.032c1.24-1.24 1.24-3.25 0-4.489z"
        fill="#738b95"
      />
      <path
        d="m193.318 299.279-23.136 23.136 18.148 18.148 23.136-23.136c-6.792-5.254-12.894-11.356-18.148-18.148z"
        fill="#b4d0d5"
      />
      <path
        d="m301.324 171.702c-8.666-3.715-18.212-5.772-28.238-5.772-5.267 0-10.401.568-15.345 1.645l-28.446 79.653c-1.288 3.608 1.386 7.403 5.217 7.403h27.557c.97 0 1.646.96 1.32 1.874l-17.046 47.731c6.125 2.463 12.667 4.104 19.492 4.789l48.912-76.829c2.348-3.688-.301-8.515-4.673-8.515h-19.452c-3.831 0-6.506-3.795-5.217-7.403z"
        fill="#f4dd45"
      />
      <path
        d="m282.851 166.589c5.474 5.529 10.055 11.944 13.509 19.011l4.963-13.898c-5.803-2.487-12-4.231-18.472-5.113z"
        fill="#eab14d"
      />
      <path
        d="m314.746 232.197c2.348-3.688-.301-8.515-4.673-8.515h-6.768c-2.687 29.333-23.034 53.557-50.317 61.945l-6.646 18.609c6.125 2.463 12.667 4.104 19.492 4.789z"
        fill="#eab14d"
      />
      <path
        d="m338.983 28.904h-32.853c-2.592 0-4.875-1.848-5.267-4.41-2.123-13.87-14.105-24.494-28.569-24.494s-26.446 10.624-28.569 24.494c-.392 2.562-2.675 4.41-5.267 4.41h-32.853c-13.469 0-24.388 10.919-24.388 24.387v39.66c0 10.034 8.134 18.168 18.168 18.168h145.817c10.034 0 18.168-8.134 18.168-18.168v-39.66c.001-13.469-10.918-24.387-24.387-24.387zm-66.689 6.138c-4.267 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726 7.726 3.459 7.726 7.726-3.459 7.726-7.726 7.726z"
        fill="#d0e2e7"
      />
      <path
        d="m338.983 28.904h-17.112c.192 1.233.292 2.497.292 3.784v39.66c0 10.034-8.134 18.168-18.168 18.168h-122.778v2.435c0 10.034 8.134 18.168 18.168 18.168h145.817c10.034 0 18.168-8.134 18.168-18.168v-39.66c.001-13.469-10.918-24.387-24.387-24.387z"
        fill="#b4d0d5"
      />
      <path
        d="m181.217 79.957v12.995c0 10.034 8.134 18.168 18.168 18.168h145.817c10.034 0 18.168-8.134 18.168-18.168v-12.995z"
        fill="#738b95"
      />
      <path
        d="m320.498 79.957c-2.879 6.234-9.186 10.559-16.503 10.559h-122.778v2.435c0 10.034 8.134 18.168 18.168 18.168h145.817c10.034 0 18.168-8.134 18.168-18.168v-12.994z"
        fill="#617881"
      />
    </g>
  </svg>
);

const IconReport = (props) => <Icon component={icon} {...props} />;

export default IconReport;
